import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { EventService } from '../../../../../../../services/event/event.service';
import { HelperService } from '../../../../../../../services/helper/helper.service';
import { UiService } from '../../../../../../../services/ui/ui.service';
import { AdminService } from '../../../../services/admin/admin.service';

@Component({
  selector: 'app-view-course-modal',
  templateUrl: './view-course-modal.component.html',
  styleUrls: ['./view-course-modal.component.css'],
})
export class ViewCourseModalComponent implements OnInit {
  public programmeName = '';
  public course = null;

  public emba = 0;
  public materialType = [
    { name: 'Slides', data: [] },
    { name: 'Cases', data: [] },
    { name: 'Additional readings', data: [] },
    { name: 'Other course matterials', data: [] },
  ];

  constructor(
    private ui: UiService,
    private event: EventService,
    public adminService: AdminService,
    public helper: HelperService
  ) {}

  ngOnInit() {
    this.event.on(
      'view-course-modal',
      'viewCourseDetails',
      ({ courseId, programmeName }) => {
        this.course = null;
        this.programmeName = programmeName;
        const emba = this.adminService.embaName.split(' ')[this.adminService.embaName.split(' ').length - 1];
        this.emba = this.helper.fromRomanOrNumToNumber(emba);
        this.getCourseDetails(courseId);
      }
    );
  }

  getCourseDetails(courseId) {
    this.ui.loader.show('view-course-modal => getCourseDetails');
    this.adminService.getCourseDetails(courseId, (err, res) => {
      this.ui.loader.hide('view-course-modal => getCourseDetails');
      if (err) {
        swal(
          'Error!',
          'Something went wrong! Please try again later.',
          'error'
        );
      } else {
        this.course = res;
        if (this.emba >= 20 || this.adminService.programmeId != 1) {
          this.materialType = this.materialType.map((type) => {
            type.data = this.course.docs.reduce((result, F, i) => {
              if (F.type === type.name) {
                result.push({ ...F, index: i });
              }
              return result;
            }, []);
            return type;
          });
        }
        // console.log(this.course);
      }
    });
  }
}



// WEBPACK FOOTER //
// G:/UTL/BMI/Admin/Admin-ANG/src/app/layout/modules/admin/programme/programme-details/modals/view-course-modal/view-course-modal.component.ts